/**
 * Random collection of useful little functions
 */

const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: 0,
    useGrouping: true,
});

export function formatNumber(n: number): string {
    return formatter.format(n);
}

export function clipString(str: string, maxLength: number): string {
    if (str.length <= maxLength) {
        return str;
    }
    return str.slice(0, maxLength - 3) + '...';
}

export function timeSinceEpoch(): number {
    const timestamp = Math.floor(Date.now() / 1000);
    return timestamp;
}

export function yesterdayOrBefore(timestamp: number): boolean {
    const now = timeSinceEpoch();
    const secondsInADay = 86400; // 24 hours * 60 minutes * 60 seconds
    const midnight = now - (now % secondsInADay); // Get the timestamp for midnight today
    return timestamp < midnight;
}

export function moveLastToFirst<T>(arr: T[]): T[] {
    if (arr.length === 0) return arr;
    const lastElement = arr.pop();
    if (lastElement !== undefined) {
        arr.unshift(lastElement);
    }
    return arr;
}

export function moveFirstToLast<T>(arr: T[]): T[] {
    if (arr.length === 0) return arr;
    const firstElement = arr.shift();
    if (firstElement !== undefined) {
        arr.push(firstElement);
    }
    return arr;
}
